const data = {
  id: 1,
  title: 'Make a sentence using given words.',
  subTitle: 'Viết câu hoàn chỉnh dựa vào các từ cho sẵn.',
  audioUrl: '',
  imageUrl: '',
  question: 'What/you/doing/now? ___',
  // answers: 'Where are you from?',
  answers: [
    { id: 1, answer: 'Where are you from?', isCorrect: true },
  ],
};

export default data;
